import * as types from './_actionTypes';

const initialState = {
  stats: {
    contentUploaded: 0,
    studentsReached: 0,
    averageScore: 0,
    pendingApprovals: 0
  },
  recentUploads: [],
  analytics: {},
  loading: false,
  error: null
};

const smeDashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_SME_DASHBOARD_REQUEST:
    case types.FETCH_SME_ANALYTICS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    
    case types.FETCH_SME_DASHBOARD_SUCCESS:
      return {
        ...state,
        loading: false,
        ...action.payload,
        error: null
      };
    
    case types.FETCH_SME_ANALYTICS_SUCCESS:
      return {
        ...state,
        loading: false,
        analytics: action.payload,
        error: null
      };
    
    case types.FETCH_SME_DASHBOARD_FAILURE:
    case types.FETCH_SME_ANALYTICS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    
    default:
      return state;
  }
};

export default smeDashboardReducer;